import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { PreviewContextProvider } from '../contexts/PreviewContext.jsx';
import { useFetchCampaignPreview } from '../hooks/useFetchCampaignPreview';

import { Navbar } from './Navbar.jsx';
import WelcomeBanner from '../../../shared/WelcomeBanner/index.jsx';
import MockProgressBar from '../../campaigns/components/Preview/MockProgressBar.jsx';
import { Posts } from '../../campaigns/components/Preview/Posts.jsx';
import { AudienceFilter } from '../../campaigns/components/Preview/AudienceFilter.jsx';
import LoadingComponent from '../../../shared/LoadingComponent';

import { setAudienceFilter } from '../../../lib/redux/campaignPreview/campaignPreviewSlice';

export const CampaignPreviewContainer = ({ id }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const audienceFilter = useSelector(
    state => state.campaignPreview.audienceFilter,
  );
  const { campaign, isFetching } = useFetchCampaignPreview({ id });
  const { color, welcomeMessage, name, posts, audiences } = campaign;
  const postsWithDates = posts.filter(post => post.publishDate !== null);
  const postsByAudience = postsWithDates.filter(post =>
    post.tiles.some(
      tile => tile.audienceId === audienceFilter || tile.audienceId === null,
    ),
  );
  const postsToShow =
    audienceFilter === 'all' ? postsWithDates : postsByAudience;

  const openFirstTile = () => {
    const firstPostWithTiles = postsToShow.find(p => p.tiles.length);

    if (!firstPostWithTiles) return;

    history.push(`/${id}/tile/${firstPostWithTiles.tiles[0].id}?preview=true`);
  };

  const dispatchAudienceFilter = audience => {
    dispatch(setAudienceFilter(audience));
  };

  if (isFetching) return <LoadingComponent />;

  return (
    <PreviewContextProvider>
      <Navbar>
        <AudienceFilter
          audiences={audiences}
          audienceFilter={audienceFilter}
          setAudienceFilter={dispatchAudienceFilter}
        />
      </Navbar>
      <WelcomeBanner
        introMessage={welcomeMessage}
        primaryColor={color}
        name={name}
        handleOnClick={openFirstTile}
      />
      <Container>
        <MockProgressBar color={color} />
        <Posts id={id} posts={postsToShow} audienceFilter={audienceFilter} />
      </Container>
    </PreviewContextProvider>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 20px auto;
  width: 828px;
`;
